import { render, staticRenderFns } from "./AccountSettingsView.vue?vue&type=template&id=40562773"
import script from "./AccountSettingsView.vue?vue&type=script&lang=ts"
export * from "./AccountSettingsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports